<template>
  <div class="relative flex items-start py-4">
    <div class="min-w-0 flex-1 text-sm">
      <fieldset>
        <legend class="block text-sm font-medium">
          {{ weekday(form.day_of_week) }}
        </legend>
        <div
          v-if="form.is_active"
          class="mt-1 bg-gray-100 rounded-md -space-y-px"
        >
          <div class="flex -space-x-px">
            <div class="w-1/2 flex-1 min-w-0">
              <label class="sr-only"> Open </label>
              <div class="relative rounded-none rounded-bl-md rounded-tl-md">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <ClockIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  v-model="form.from"
                  @update:modelValue="fieldChanged($event)"
                  v-maska="time"
                  type="text"
                  class="block rounded-none rounded-bl-md rounded-tl-md w-full pl-10 sm:text-sm border-gray-400"
                  placeholder="Open"
                />
              </div>
            </div>
            <div class="flex-1 min-w-0">
              <label class="sr-only"> Close </label>
              <div class="relative rounded-none rounded-br-md rounded-tr-md">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <ClockIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  v-model="form.to"
                  @update:modelValue="fieldChanged($event)"
                  v-maska="time"
                  type="text"
                  class="block rounded-none rounded-br-md rounded-tr-md w-full pl-10 sm:text-sm border-gray-400"
                  placeholder="Close"
                />
              </div>
            </div>
          </div>
        </div>
        <legend
          v-if="form.is_active"
          class="block text-xs text-gray mt-2 p-1"
        >
          Order Requirements
        </legend>
        <div
          v-if="form.is_active"
          class="mt-1 bg-gray-100 rounded-md -space-y-px"
        >
          <div class="flex -space-x-px">
            <div class="w-1/2 flex-1 min-w-0">
              <label class="sr-only">By</label>
              <div class="relative rounded-none rounded-bl-md rounded-tl-md">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <ClockIcon
                    class="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </div>
                <input
                  v-model="form.order_by_time"
                  @update:modelValue="fieldChanged($event)"
                  v-maska="time"
                  type="text"
                  class="block rounded-none rounded-bl-md rounded-tl-md w-full pl-10 sm:text-sm border-gray-400"
                  placeholder="Order by"
                />
              </div>
            </div>
            <div class="flex-1 min-w-0">
              <div class="relative rounded-none rounded-br-md">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-600 sm:text-sm">$</span>
                </div>
                <input
                  v-model="form.min_amount"
                  @update:modelValue="fieldChanged($event)"
                  v-maska="'#*.##'"
                  type="text"
                  class="block rounded-none rounded-br-md rounded-tr-md w-full pl-7 pr-12 sm:text-sm border-gray-400"
                  placeholder="Min order"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="form.is_active"
          class="mt-2 bg-gray-100 rounded-md -space-y-px"
        >
          <div class="block p-1">
            <SwitchGroup
              as="div"
              class="flex items-center justify-start"
            >
              <Switch
                v-model="form.has_delivery"
                @update:modelValue="fieldChanged($event)"
                :class="[
                  form.has_delivery ? 'bg-blue-600' : 'bg-gray-400',
                  'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600'
                ]"
              >
                <span
                  aria-hidden="true"
                  :class="[
                    form.has_delivery ? 'translate-x-5' : 'translate-x-0',
                    'pointer-events-none inline-block h-5 w-5 rounded-full bg-gray-100 ring-0 transition ease-in-out duration-200'
                  ]"
                />
              </Switch>
              <span class="grow flex flex-col pl-3">
                <SwitchLabel
                  as="span"
                  class="text-sm font-medium text-gray-900"
                  passive
                >
                  Has Delivery?
                </SwitchLabel>
              </span>
            </SwitchGroup>
          </div>
        </div>
        <div
          v-if="form.is_active && form.has_delivery"
          class="mt-2"
        >
          <div class="block">
            <div class="relative rounded-none rounded-md">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span class="text-gray-600 sm:text-sm">$</span>
              </div>
              <input
                v-model="form.delivery_fee"
                @update:modelValue="fieldChanged($event)"
                v-maska="'#*.##'"
                type="text"
                class="block w-full pl-7 pr-12 sm:text-sm border-gray-400 rounded-md"
                placeholder="Delivery fee"
              />
            </div>
          </div>
        </div>
        <div
          v-if="form.is_active && form.has_delivery"
          class="mt-2"
        >
          <div class="block">
            <div class="relative rounded-none rounded-md">
              <input
                v-model="form.max_deliveries"
                @update:modelValue="fieldChanged($event)"
                v-maska="'#####'"
                type="text"
                class="block w-full pr-12 sm:text-sm border-gray-400 rounded-md"
                placeholder="Max # of Deliveries"
              />
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <!--        <div class="ml-3 flex items-center h-5">-->
    <!--            <input v-model="form.is_active" @update:modelValue="fieldChanged($event)" type="checkbox" class="h-4 w-4 border-gray-400 rounded" />-->
    <!--        </div>-->
  </div>
</template>

<script>
import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import { ClockIcon } from '@heroicons/vue/outline'
import displaysWeekdays from '@/Mixins/displaysWeekdays'
import time from '@/utils/Masks/time'

export default {
  mixins: [displaysWeekdays],

  components: {
    Switch,
    SwitchDescription,
    SwitchGroup,
    SwitchLabel,
    ClockIcon
  },

  props: {
    day: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: {
        day_of_week: null,
        to: null,
        from: null,
        order_by_time: null,
        delivery_fee: null,
        min_amount: null,
        max_deliveries: null,
        has_delivery: null,
        is_active: null
      },
      time
    }
  },

  created() {
    this.setDay(this.day)
  },

  watch: {
    form: {
      deep: true,
      handler() {
        this.emitDay()
      }
    }
  },

  methods: {
    setDay(day) {
      this.form = _.merge(this.form, day, { is_active: true })
    },
    fieldChanged(event) {
      this.emitDay()
    },
    emitDay() {
      // cloned to avoid interferring with masking on inputs; emit transformed form
      let form = _.merge({}, this.form)

      form.delivery_fee = !form.delivery_fee ? null : parseFloat(form.delivery_fee)
      form.min_amount = !form.min_amount ? null : parseFloat(form.min_amount)
      form.max_deliveries = !form.max_deliveries ? null : parseInt(form.max_deliveries)
      form.is_active = true // Override and ensure always active.

      this.$emit('update:day', form)
    }
  }
}
</script>
